import React from 'react';
import { observer } from 'mobx-react';
import storeLoader from 'app/stores/storeLoader';
import AlertingTable from 'app/views/alerting/components/AlertingTable';
import AlertCollection from 'app/stores/alerting/AlertCollection';

@storeLoader('$alerting.policyCollection')
@observer
class JourneyAlertResponse extends React.Component {
  state = {
    collection: new AlertCollection()
  };

  componentDidMount() {
    const { collection } = this.state;
    const { query } = this.props;
    // Override because we don't need server filters and it breaks inline filters.
    collection.serverSortableFields = [];
    // Override because we don't want to clearFilters on result collapse/expand.
    collection.clearFilters = () => {};
    // flatten these because the collection re-nests under filter before fetching.
    const { filter, pagination = {} } = query.get ? query.get('query') : query;
    collection.setServerFilter(
      filter,
      {},
      {
        data: {
          offset: pagination.offset ?? 0,
          limit: pagination.limit || 1000,
          pagination: { includeTotalCount: true }
        }
      }
    );
  }

  render() {
    const { useVirtualizedTable = true } = this.props;
    const { collection } = this.state;

    return <AlertingTable collection={collection} miniKebab useVirtualizedTable={useVirtualizedTable} />;
  }
}

export default JourneyAlertResponse;
